import React from "react";
import { Route } from "react-router-dom";

import Layout from "../components/Layout/Layout";
import useAuthSession from "../hooks/useAuthSession";

export default function Router({
	component: Component,
	title,
	...rest
}) {
	const authSession = useAuthSession();
	const isUserLogin = authSession.isLoggedIn;


	// useEffect(() => {
	//     //dispatch(userActions.logout()); 

	// 	if(isUserLogin == null || isUserLogin == undefined || isUserLogin == false){
	// 		history.push('/login');
	// 	}
	// }, []);
	/**
	 * Redirect user to SignIn page if he tries to access a private route
	 * without authentication.
	 */
	//   if (isPrivate && !signed) {
	//     return <Redirect to="/" />;
	//   }

	/**
	 * Redirect user to Main page if he tries to access a non private route
	 * (SignIn or SignUp) after being authenticated.
	 */
	//   if (!isPrivate && signed) {
	//     return <Redirect to="/dashboard" />;
	//   }

	//   const Layout = signed ? AuthLayout : DefaultLayout;

	/**
	 * If not included on both previous cases, redirect user to the desired route.
	 */

	if (isUserLogin == null || !isUserLogin) {
		return (
			<Route
				{...rest}
				render={props => (
					<Component {...props} />

				)}
			/>
		);
	} else {
		return (
			<Route
				{...rest}
				render={props => (
					<Layout title={title} footerVariant={rest.footerVariant}>
						<Component {...props} />
								
					</Layout>
					 

				)}
			/>
		);
	}
}


